import React from 'react';
import styles from './EmptyState.module.scss';

export interface EmptyStateAction {
  label: string;
  onClick: () => void;
}

export interface EmptyStateProps {
  heading: string;
  icon?: React.ReactNode;
  description?: string;
  action?: EmptyStateAction;
  secondaryAction?: EmptyStateAction;
  className?: string;
  children?: React.ReactNode;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  heading,
  icon,
  description,
  action,
  secondaryAction,
  className,
  children,
}) => {
  // Defensive validation for action objects in case of partial/untyped consumers
  const validAction =
    action && typeof action.label === 'string' && action.label && typeof action.onClick === 'function'
      ? action
      : null;
  const validSecondary =
    secondaryAction &&
    typeof secondaryAction.label === 'string' &&
    secondaryAction.label &&
    typeof secondaryAction.onClick === 'function'
      ? secondaryAction
      : null;

  return (
    <div className={`${styles.root} ${className ?? ''}`} role="status">
      {icon && (
        <div className={styles.iconContainer} aria-hidden="true">
          {icon}
        </div>
      )}
      <p className={styles.heading}>{heading}</p>
      {description && <p className={styles.description}>{description}</p>}
      {children}
      {validAction && (
        <button
          className={styles.primaryAction}
          onClick={validAction.onClick}
          type="button"
        >
          {validAction.label}
        </button>
      )}
      {validSecondary && (
        <button
          className={styles.secondaryAction}
          onClick={validSecondary.onClick}
          type="button"
        >
          {validSecondary.label}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
